import { LocalConfig } from '@typesApp/LocalConfig'

const KEY_LOCAL_CONFIG = 'direct-billing.local-config'

export const getLocalConfig = (): LocalConfig => {
  try {
    return JSON.parse(window.localStorage.getItem(KEY_LOCAL_CONFIG) ?? '{}')
  } catch (e) {
    return {} as LocalConfig
  }
}